import ApiBase from './api-base'
import * as Bugsnag from '@/modules/services/bugsnag'

export class BffLayoutConfig extends ApiBase {
  constructor () {
    super()

    this.url = '/web/v1/layouts'
    this.requestConfig = {
      headers: {
        'X-SWA': 'web'
      }
    }
  }

  async fetch () {
    try {
      const { data } = await this.client.get(this.url, this.requestConfig)
      return { success: true, data }
    } catch (e) {
      Bugsnag.notifyBugsnag(e)
      return { success: false, data: null, message: e.message }
    }
  }
}
